import { render, staticRenderFns } from "./ModalAICloseConfirm.vue?vue&type=template&id=98700f40&"
import script from "./ModalAICloseConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalAICloseConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports